import * as React from 'react';

export type RequiredIndicatorProps = {
    isOk: boolean
}

export const RequiredIndicator = (props: RequiredIndicatorProps) => (
    <i title={`${props.isOk ? "" : "Required"}`} className={`${props.isOk ? "fa-circle-check text-success" : "fa-circle-exclamation text-warning"} fa-solid`}></i>
);